<template>
  <v-container mt-7>
    <v-row>
      <v-col>
        <v-card>
          <v-tabs v-model="tab" background-color="secondary" dark grow>
            <v-tab v-for="item in items" :key="item">{{ item }}</v-tab>
          </v-tabs>

          <v-tabs-items v-model="tab">
            <v-tab-item v-for="item in items" :key="item">
              <v-card v-if="item == 'Users'" class="elevation-0">
                <v-card-title primary-title>
                  <v-row>
                    <v-col lg="4" sm="12">User Administration</v-col>
                  </v-row>
                </v-card-title>
                <v-card-text>
                  <v-row>
                    <v-col cols="9" class="py-0">
                      <v-text-field
                        class="py-0"
                        v-model="search"
                        label="Search"
                        append-icon="mdi-search"
                        single-line
                        hide-details
                      ></v-text-field>
                    </v-col>

                    <v-col cols="3" class="py-0">
                      <v-btn color="secondary" dark class="float-right" @click="userDialog = true">
                        <v-icon>mdi-account-plus</v-icon>Add User
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-data-table
                  :loading="loading"
                  :headers="userHeaders"
                  :items="users"
                  :search="search"
                  class="elevation-1 col-md-12 m-auto"
                >
                  <template v-slot:item.actions="{ item }">
                    <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
                    <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
                  </template>

                  <template v-slot:item.reset="{ item }">
                    <v-btn v-if="(item.firstLogin != null ? item.firstLogin : item.first_login) === true" x-small width="100%" outlined color="green"
                      >Awaiting Login</v-btn
                    >
                    <v-btn
                      v-else
                      x-small
                      outlined
                      width="100%"
                      color="secondary"
                      @click="openPassDialog(item)"
                      >Reset Password</v-btn
                    >
                  </template>
                  <!-- <template v-slot:item.Role="{ item }">
                    <tr v-if="item.Role !=== 'Superuser'">
                      {{
                        item
                      }}
                    </tr>
                  </template> -->
                </v-data-table>
              </v-card>

              <v-card v-if="item == 'Affiliates'" class="elevation-0">
                <v-card-title primary-title>
                  <v-row>
                    <v-col lg="4" sm="12">Affiliate Administration</v-col>
                  </v-row>
                </v-card-title>
                <v-card-text>
                  <v-row>
                    <v-col cols="6" class="py-0">
                      <v-text-field
                        class="py-0"
                        v-model="search"
                        label="Search"
                        append-icon="mdi-search"
                        single-line
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col v-if="user.role === 'Superuser'" align="right" cols="6" class="py-0">
                      <v-btn class="mx-1" @click="checkAffiliatesModal()">Check Affiliates</v-btn>
                      <v-btn color="secondary" dark class="mx-1" @click="createAffiliate">
                        <v-icon>mdi-account-plus</v-icon>Add Affiliate
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-data-table
                  :loading="loading"
                  :headers="affiliatesHeaders"
                  :items="affiliates"
                  :search="search"
                  class="elevation-1 col-md-12 m-auto"
                >
                  <template v-slot:item.actions="{ item }">
                    <v-icon small class="mr-2" @click="editAffiliate(item)">mdi-pencil</v-icon>
                  </template>
                </v-data-table>
              </v-card>

              <v-dialog v-model="checkAffiliates" max-width="900px">
                <v-card>
                  <v-card-title> Check Affiliates </v-card-title>
                  <v-card-text>
                    <v-row>
                      <v-col cols="6" sm="6" md="6">
                        <v-select
                          v-model="editedItem.organization"
                          :items="organizations"
                          label="Organization"
                          @change="getInsurances()"
                        ></v-select>
                      </v-col>
                      <v-col cols="6" sm="6" md="6">
                        <v-select
                          v-model="insChoice"
                          :items="insurances"
                          label="Insurance"
                          @change="getGroups()"
                        ></v-select>
                      </v-col>
                    </v-row>
                    <v-row v-if="affiliatesData">
                      <v-col v-if="load" cols="12" class="text-center">
                        <v-progress-circular
                          color="secondary"
                          indeterminate
                          :size="50"
                          :width="3"
                        ></v-progress-circular>
                      </v-col>
                      <v-layout child-flex>
                        <v-simple-table :loading="loading" :items="affiliatesData">
                          <tbody>
                            <tr v-for="item in affiliatesData" :key="item.collection">
                              <td>{{ item.collection }}</td>
                              <td>{{ item.id.length > 0 ? item.id.join(', ') : 'No Data' }}</td>
                            </tr>
                          </tbody>
                        </v-simple-table>
                      </v-layout>
                    </v-row>
                    <v-row>
                      <v-col align="left" cols="6" class="py-2">
                        <v-btn text @click="checkAffiliatesReport()" color="secondary"
                          >Run Report</v-btn
                        >
                        <v-btn text @click="checkAffiliatesModal()">Close</v-btn>
                      </v-col>
                      <v-col align="right" cols="6" class="py-2">
                        <ExportCSV :data="affiliatesData" v-if="affiliatesData.length > 0">
                          <v-btn color="secondary" text>Export to CSV</v-btn>
                        </ExportCSV>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-dialog>

              <v-card v-if="item == 'Organizations'" class="elevation-0">
                <v-card-title primary-title>
                  <v-row>
                    <v-col lg="4" sm="12">Organizations</v-col>
                  </v-row>
                </v-card-title>
                <v-card-text>
                  <v-row>
                    <v-col cols="12" class="py-0">
                      <v-text-field
                        class="py-0"
                        v-model="search"
                        label="Search"
                        append-icon="mdi-search"
                        single-line
                        hide-details
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-data-table
                  :loading="loading"
                  :headers="organizationHeaders"
                  :items="orgs"
                  :search="search"
                  class="elevation-1 col-md-12 m-auto"
                >
                  <template v-slot:item.actions="{ item }">
                    <v-icon small class="mr-2" @click="editOrganization(item)">mdi-pencil</v-icon>
                  </template>
                </v-data-table>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="passDialog" max-width="500px">
      <template>
        <v-card>
          <v-card-title> Password Reset </v-card-title>
          <v-card-text>
            <v-row>
              <v-col>
                Are you sure you want to reset the password for {{ selectedUser.email }}?
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-btn text @click="resetPass()" color="secondary">Yes</v-btn>
            <v-btn text @click="passDialog = false">No</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

    <v-dialog v-model="userDialog" max-width="500px">
      <template>
        <v-form ref="form" method="post" action="/api/register" v-model="valid" lazy-validation>
          <v-card>
            <v-card-title>
              <span class="headline">{{ editedIndex > -1 ? 'Edit User' : 'New User' }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="6" sm="6" md="6">
                    <v-text-field
                      v-model="editedItem.username"
                      :rules="[(v) => !!v || 'Username is required']"
                      label="Username"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6" sm="6" md="6">
                    <v-select
                      v-model="editedItem.role"
                      :rules="[(v) => !!v || 'Role is required']"
                      :items="roles"
                      label="Role"
                      required
                    ></v-select>
                  </v-col>
                  <v-col cols="6" sm="6" md="6">
                    <v-text-field
                      v-model="editedItem.email"
                      :rules="[
                        (v) => !!v || 'E-mail is required',
                        (v) => /.+@.+\..+/.test(v) || 'E-mail must be valid',
                        emailCheck || 'Email has already been registered',
                      ]"
                      label="Email"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" sm="6" md="6">
                    <v-select
                      v-model="editedItem.organization"
                      :items="organizations"
                      label="Organization"
                      @change="getInsurances()"
                    ></v-select>
                  </v-col>
                  <v-col cols="6" sm="6" md="6">
                    <v-select
                      v-model="editedItem.insurance"
                      multiple
                      :items="insurances"
                      label="Insurance"
                      @change="getGroups()"
                    ></v-select>
                  </v-col>
                  <v-col cols="6" sm="6" md="6">
                    <v-autocomplete
                      v-if="
                        editedItem.role === 'Group' ||
                        editedItem.role === 'Provider' ||
                        editedItem.role === 'Clinical'
                      "
                      v-model="editedItem.group"
                      :items="groups"
                      multiple
                      label="Group"
                      @change="getProvs()"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
                <!--<v-row>
                  <v-col cols="6" sm="6" md="6">
                    <v-select
                      v-if="editedItem.role === 'Provider' || editedItem.role === 'Clinical'"
                      v-model="editedItem.provider"
                      :items="providers"
                      label="Provider"
                      multiple
                      @change="getProvLocs()"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-select
                      v-if="editedItem.role === 'Clinical'"
                      v-model="editedItem.location"
                      :items="locations"
                      label="Locations"
                      multiple
                    ></v-select>
                  </v-col> -->
                <!-- <v-col cols="12" sm="6" md="4">
                    <v-select
                      v-model="superUserSettings.app_plan"
                      :items="app_plan != null ? app_plan : []"
                      label="App Plan"
                      :disabled="adminDisabled"
                      required
                    ></v-select>
                  </v-col> -->
                <!-- </v-row> -->
                <!-- <v-checkbox
                  v-model="editedItem.notifications"
                  label="Notifications"
                  required
                  :disabled="adminDisabled"
                ></v-checkbox>
                <v-checkbox
                  v-model="superUserSettings.redox"
                  label="Redox"
                  required
                  :disabled="adminDisabled"
                ></v-checkbox>
                <v-checkbox
                  v-model="superUserSettings.ai"
                  label="AI"
                  required
                  :disabled="adminDisabled"
                ></v-checkbox> -->
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="close">Cancel</v-btn>
              <v-btn color="secondary" :disabled="!valid" text @click="validate">Save</v-btn>
              <div class="text-center">
                <v-snackbar v-model="snackbar" color="error" :timeout="4000">
                  <v-icon class="mx-3">mdi-alert-circle-outline</v-icon>{{ duplicateEmailText }}
                </v-snackbar>
              </div>
            </v-card-actions>
          </v-card>
        </v-form>
      </template>
    </v-dialog>

    <v-dialog v-model="affiliateDialog" max-width="700px">
      <template>
        <v-form ref="affiliateForm" method="post" v-model="valid" lazy-validation>
          <v-card>
            <v-card-title>
              <span class="headline">{{
                editedAffiliateIndex > -1 ? 'Edit Affiliate' : 'New Affiliate'
              }}</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-alert type="error">
                      Be careful when editing affiliates. Incorrect configuration will cause all
                      reports to be incorrect.
                    </v-alert>
                  </v-col>
                  <v-col cols="12" md="5">
                    <v-select
                      v-model="editedAffiliate['IPA/MSO']"
                      :items="organizations"
                      label="IPA/MSO"
                      @change="getInsurances()"
                    ></v-select>
                  </v-col>

                  <v-col cols="12" md="5">
                    <v-select
                      v-model="editedAffiliate.Plan"
                      :items="insurances"
                      label="Insurance"
                      @change="getGroups()"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-checkbox
                      v-model="editedAffiliate.Active"
                      label="Active"
                      required
                    ></v-checkbox>
                  </v-col>
                  <v-col v-if="activeDatePicker && !creatingAffiliate" cols="12" md="5">
                    <v-menu
                      ref="activeDatePickerFlag"
                      v-model="activeDatePickerFlag"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      outlined
                      dense
                      min-width="290px"
                      max-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="activeDate"
                          label="Active/Incative Date"
                          append-icon="mdi-calendar"
                          readonly
                          outlined
                          dense
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker ref="picker" v-model="activeDate">
                        <v-spacer></v-spacer>
                        <v-btn outlined color="primary" @click="activeDatePickerFlag = false">
                          Cancel
                        </v-btn>
                        <v-btn
                          depressed
                          color="primary"
                          @click="$refs.activeDatePickerFlag.save(activeDate)"
                        >
                          OK
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="editedAffiliate.Group_Name"
                      :items="groups"
                      label="Group"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="editedAffiliate.Provide_Name"
                      :items="providers"
                      label="Name"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="editedAffiliate.Center_PCP_Number"
                      :items="locations"
                      label="Center/PCP Number"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="editedAffiliate.Center_Location"
                      :items="locations"
                      label="Locations"
                      multiple
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <div class="subtitle-1">Reconciliation Settings</div>
                  </v-col>
                  <v-col cols="12" md="6" class="pb-0">
                    <v-text-field
                      outlined
                      dense
                      type="number"
                      v-model="editedAffiliate.A_REV_RATE"
                      label="Part A Revenue Rate"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" class="pb-0">
                    <v-text-field
                      outlined
                      dense
                      type="number"
                      v-model="editedAffiliate.A_EXP_RATE"
                      label="Part A Expense Rate"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" class="pb-0">
                    <v-text-field
                      outlined
                      dense
                      type="number"
                      v-model="editedAffiliate.B_REV_RATE"
                      label="Part B Revenue Rate"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" class="pb-0">
                    <v-text-field
                      outlined
                      dense
                      type="number"
                      v-model="editedAffiliate.B_EXP_RATE"
                      label="Part B Expense Rate"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" class="pb-0">
                    <v-text-field
                      outlined
                      dense
                      type="number"
                      v-model="editedAffiliate.D_REV_RATE"
                      label="Part D Revenue Rate"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" class="pb-0">
                    <v-text-field
                      outlined
                      dense
                      type="number"
                      v-model="editedAffiliate.D_EXP_RATE"
                      label="Part D Expense Rate"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" class="pb-0">
                    <v-text-field
                      outlined
                      dense
                      type="number"
                      v-model="editedAffiliate.TH_1"
                      label="Member Threshold 1"
                      hint="Enter membership count at which this rate will apply"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" class="pb-0">
                    <v-text-field
                      outlined
                      dense
                      type="number"
                      v-model="editedAffiliate.TH1_RATE"
                      label="Threshold Rate 1"
                      hint="Enter percentage rate in decimal form"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" class="pb-0">
                    <v-text-field
                      outlined
                      dense
                      type="number"
                      v-model="editedAffiliate.TH_2"
                      label="Member Threshold 2"
                      hint="Enter membership count at which this rate will apply"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" class="pb-0">
                    <v-text-field
                      outlined
                      dense
                      type="number"
                      v-model="editedAffiliate.TH2_RATE"
                      label="Threshold Rate 2"
                      hint="Enter percentage rate in decimal form"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" class="pb-0">
                    <v-text-field
                      outlined
                      dense
                      type="number"
                      v-model="editedAffiliate.TH_3"
                      label="Member Threshold 3"
                      hint="Enter membership count at which this rate will apply"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" class="pb-0">
                    <v-text-field
                      outlined
                      dense
                      type="number"
                      v-model="editedAffiliate.TH3_RATE"
                      label="Threshold Rate 3"
                      hint="Enter percentage rate in decimal form"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" class="pb-0">
                    <v-text-field
                      outlined
                      dense
                      type="number"
                      v-model="editedAffiliate.TH_4"
                      label="Member Threshold 4"
                      hint="Enter membership count at which this rate will apply"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" class="pb-0">
                    <v-text-field
                      outlined
                      dense
                      type="number"
                      v-model="editedAffiliate.TH4_RATE"
                      label="Threshold Rate 4"
                      hint="Enter percentage rate in decimal form"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" class="pb-0">
                    <v-text-field
                      outlined
                      dense
                      type="number"
                      v-model="editedAffiliate.TH_5"
                      label="Member Threshold 5"
                      hint="Enter membership count at which this rate will apply"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" class="pb-0">
                    <v-text-field
                      outlined
                      dense
                      type="number"
                      v-model="editedAffiliate.TH5_RATE"
                      label="Threshold Rate 5"
                      hint="Enter percentage rate in decimal form"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="closeAffiliate">Cancel</v-btn>
              <v-btn color="secondary" :disabled="!valid" text @click="validateAffiliate"
                >Save</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-form>
      </template>
    </v-dialog>

    <v-dialog v-model="organizationDialog" max-width="700px">
      <template>
        <v-form ref="organizationForm" method="post" v-model="valid" lazy-validation>
          <v-card>
            <v-card-title>
              <span class="headline">Edit Organization</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-alert type="error">
                      Be careful when editing organisations. Incorrect configuration will cause some
                      reports to be incorrect.
                    </v-alert>
                  </v-col>
                  <v-col cols="12" md="5">
                    <v-select
                      v-model="editedOrganization.TYPE"
                      :items="orgTypes"
                      label="Organization Type"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" md="5">
                    <v-select
                      v-model="editedOrganization.Plan"
                      :items="insurances"
                      label="Insurance"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-checkbox
                      v-model="editedOrganization.Active"
                      label="Active"
                      required
                    ></v-checkbox>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field v-model="editedOrganization.IPA" label="IPA"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field v-model="editedOrganization.Name" label="Name"></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <div class="subtitle-1">Reconciliation Settings</div>
                  </v-col>
                  <v-col cols="12" class="pb-0">
                    <v-text-field
                      outlined
                      dense
                      v-model.number="editedOrganization.DS_RATE"
                      label="Downstream Rate"
                      hint="Enter downstream rate that will be used if no membership thresholds are set"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" class="pb-0">
                    <v-text-field
                      outlined
                      dense
                      type="number"
                      v-model="editedOrganization.A_REV_RATE"
                      label="Part A Revenue Rate"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" class="pb-0">
                    <v-text-field
                      outlined
                      dense
                      type="number"
                      v-model="editedOrganization.A_EXP_RATE"
                      label="Part A Expense Rate"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" class="pb-0">
                    <v-text-field
                      outlined
                      dense
                      type="number"
                      v-model="editedOrganization.B_REV_RATE"
                      label="Part B Revenue Rate"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" class="pb-0">
                    <v-text-field
                      outlined
                      dense
                      type="number"
                      v-model="editedOrganization.B_EXP_RATE"
                      label="Part B Expense Rate"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" class="pb-0">
                    <v-text-field
                      outlined
                      dense
                      type="number"
                      v-model="editedOrganization.D_REV_RATE"
                      label="Part D Revenue Rate"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" class="pb-0">
                    <v-text-field
                      outlined
                      dense
                      type="number"
                      v-model="editedOrganization.D_EXP_RATE"
                      label="Part D Expense Rate"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" class="pb-0">
                    <v-text-field
                      outlined
                      dense
                      type="number"
                      v-model="editedOrganization.TH_1"
                      label="Member Threshold 1"
                      hint="Enter membership count at which this rate will apply"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" class="pb-0">
                    <v-text-field
                      outlined
                      dense
                      type="number"
                      v-model="editedOrganization.TH1_RATE"
                      label="Threshold Rate 1"
                      hint="Enter percentage rate in decimal form"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" class="pb-0">
                    <v-text-field
                      outlined
                      dense
                      type="number"
                      v-model="editedOrganization.TH_2"
                      label="Member Threshold 2"
                      hint="Enter membership count at which this rate will apply"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" class="pb-0">
                    <v-text-field
                      outlined
                      dense
                      type="number"
                      v-model="editedOrganization.TH2_RATE"
                      label="Threshold Rate 2"
                      hint="Enter percentage rate in decimal form"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" class="pb-0">
                    <v-text-field
                      outlined
                      dense
                      type="number"
                      v-model="editedOrganization.TH_3"
                      label="Member Threshold 3"
                      hint="Enter membership count at which this rate will apply"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" class="pb-0">
                    <v-text-field
                      outlined
                      dense
                      type="number"
                      v-model="editedOrganization.TH3_RATE"
                      label="Threshold Rate 3"
                      hint="Enter percentage rate in decimal form"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" class="pb-0">
                    <v-text-field
                      outlined
                      dense
                      type="number"
                      v-model="editedOrganization.TH_4"
                      label="Member Threshold 4"
                      hint="Enter membership count at which this rate will apply"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" class="pb-0">
                    <v-text-field
                      outlined
                      dense
                      type="number"
                      v-model="editedOrganization.TH4_RATE"
                      label="Threshold Rate 4"
                      hint="Enter percentage rate in decimal form"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" class="pb-0">
                    <v-text-field
                      outlined
                      dense
                      type="number"
                      v-model="editedOrganization.TH_5"
                      label="Member Threshold 5"
                      hint="Enter membership count at which this rate will apply"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" class="pb-0">
                    <v-text-field
                      outlined
                      dense
                      type="number"
                      v-model="editedOrganization.TH5_RATE"
                      label="Threshold Rate 5"
                      hint="Enter percentage rate in decimal form"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="closeOrganization">Cancel</v-btn>
              <v-btn color="secondary" :disabled="!valid" text @click="validateOrganization"
                >Save</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-form>
      </template>
    </v-dialog>
    <v-snackbar v-model="savedChanges" color="primary" timeout="4000">
      <h3>Changes have been Saved...</h3>
    </v-snackbar>
  </v-container>
</template>

<script>
import axios from 'axios';
import ExportCSV from 'vue-json-csv';

export default {
  components: {
    ExportCSV,
  },
  data: () => ({
    load: false,
    insChoice: '',
    affiliatesData: [],
    checkAffiliates: false,
    duplicateEmailText: 'This email is already registered',
    snackbar: false,
    emailCheck: true,
    loading: true,
    items: ['Users', 'Affiliates', 'Organizations'],
    tab: null,
    superUserSettings: '',
    userDialog: false,
    passDialog: false,
    affiliateDialog: false,
    organizationDialog: false,
    valid: true,
    roles: ['Superuser', 'Admin', 'Manager', 'Group', 'Provider', 'Clinical'],
    app_plan: [],
    search: '',
    searchAffiliates: '',
    orgTypes: ['ORG', 'GROUP'],
    organizations: [],
    groups: [],
    providers: [],
    locations: [],
    insurances: [],
    user: '',
    selectedUser: '',
    insurances: [],
    formTitle: '',
    organizationHeaders: [
      { text: 'IPA', value: 'IPA' },
      { text: 'Type', value: 'TYPE' },
      { text: 'Name', value: 'Name' },
      { text: 'Plan', value: 'Plan' },
      { text: 'Actions', value: 'actions', sortable: false },
    ],
    affiliatesHeaders: [
      { text: 'IPA/MSO', value: 'IPA/MSO' },
      { text: 'Group', value: 'Group_Name' },
      { text: 'Name', value: 'Provide_Name' },
      { text: 'PCP/Center Number', value: 'Center_PCP_Number' },
      { text: 'Location', value: 'Center_Location' },
      { text: 'Insurance', value: 'Plan' },
      { text: 'Actions', value: 'actions', sortable: false },
    ],
    userHeaders: [
      {
        text: 'Username',
        align: 'start',
        sortable: false,
        value: 'username',
      },
      { text: 'Role', value: 'role' },
      { text: 'Email', value: 'email' },
      { text: 'Insurance', value: 'insurance' },
      { text: 'Organization', value: 'organization' },
      { text: 'Group', value: 'group' },
      { text: 'Provider', value: 'provider' },
      { text: 'Location', value: 'location' },
      // { text: "App Plan", value: "app_plan" },
      // { text: "Notifications", value: "notifications" },
      // { text: "Redox", value: "redox" },
      // { text: "AI", value: "AI" },
      { text: 'Actions', value: 'actions', sortable: false },
      { text: 'Reset Password', value: 'reset' },
    ],
    orgs: [],
    affiliates: [],
    users: [],
    editedIndex: -1,
    dataCopy: {},
    editedItem: {
      username: '',
      role: '',
      email: '',
      insurance: '',
      organization: '',
      group: '',
      provider: [],
      location: [],
    },
    defaultItem: {
      username: '',
      role: '',
      email: '',
      insurance: '',
      organization: '',
      group: '',
      provider: [],
      location: [],
    },
    defaultAffiliate: {
      Active: '',
      'IPA/MSO': '',
      Group_Name: '',
      Provide_Name: '',
      Center_PCP_Number: '',
      Center_Location: '',
      County_Name: '',
      City: '',
      State: '',
      Zip: '',
      Affiliate_or_WOC: '',
      Line_of_Business: '',
      'Grouper_#': '',
      Plan: '',
      A_REV_RATE: '',
      B_REV_RATE: '',
      D_REV_RATE: '',
      A_EXP_RATE: '',
      B_EXP_RATE: '',
      D_EXP_RATE: '',
      TH_1: '',
      TH_2: '',
      TH_3: '',
      TH_4: '',
      TH_5: '',
      TH1_RATE: '',
      TH2_RATE: '',
      TH3_RATE: '',
      TH4_RATE: '',
      TH5_RATE: '',
    },
    editedAffiliateIndex: -1,
    editedAffiliate: {
      Active: false,
      'IPA/MSO': '',
      Group_Name: '',
      Provide_Name: '',
      Center_PCP_Number: '',
      Center_Location: '',
      County_Name: '',
      City: '',
      State: '',
      Zip: '',
      Affiliate_or_WOC: '',
      Line_of_Business: '',
      'Grouper_#': '',
      Plan: '',
      A_REV_RATE: '',
      B_REV_RATE: '',
      D_REV_RATE: '',
      A_EXP_RATE: '',
      B_EXP_RATE: '',
      D_EXP_RATE: '',
      TH_1: '',
      TH_2: '',
      TH_3: '',
      TH_4: '',
      TH_5: '',
      TH1_RATE: '',
      TH2_RATE: '',
      TH3_RATE: '',
      TH4_RATE: '',
      TH5_RATE: '',
      Edits: [],
    },
    defaultOrganization: {
      Active: '',
      IPA: '',
      Name: '',
      TYPE: '',
      Plan: '',
      DS_RATE: '',
      A_REV_RATE: '',
      B_REV_RATE: '',
      D_REV_RATE: '',
      A_EXP_RATE: '',
      B_EXP_RATE: '',
      D_EXP_RATE: '',
      TH_1: '',
      TH_2: '',
      TH_3: '',
      TH_4: '',
      TH_5: '',
      TH1_RATE: '',
      TH2_RATE: '',
      TH3_RATE: '',
      TH4_RATE: '',
      TH5_RATE: '',
    },
    editedOrganizationIndex: -1,
    editedOrganization: {
      Active: '',
      IPA: '',
      Name: '',
      TYPE: '',
      Plan: '',
      DS_RATE: '',
      A_REV_RATE: '',
      B_REV_RATE: '',
      D_REV_RATE: '',
      A_EXP_RATE: '',
      B_EXP_RATE: '',
      D_EXP_RATE: '',
      TH_1: '',
      TH_2: '',
      TH_3: '',
      TH_4: '',
      TH_5: '',
      TH1_RATE: '',
      TH2_RATE: '',
      TH3_RATE: '',
      TH4_RATE: '',
      TH5_RATE: '',
    },
    savedChanges: false,
    creatingAffiliate: false,
    activeDatePicker: false,
    activeDatePickerFlag: false,
    activeDate: '',
    statusChange: false,
  }),

  watch: {
    'editedItem.email': function () {
      this.emailCheck = true;
    },
    editedAffiliate: {
      handler() {
        if (JSON.stringify(this.dataCopy.Active) !== JSON.stringify(this.editedAffiliate.Active)) {
          this.activeDatePicker = true;
          this.statusChange = true;
        } else {
          this.activeDatePicker = false;
          this.statusChange = false;
        }
      },
      deep: true,
    },
    checkAffiliates() {
      if (this.checkAffiliates === false) {
        this.affiliatesData = [];
        this.insChoice = [];
        this.editedItem.organization = [];
      }
    },
    userDialog(val) {
      this.getInsurances();
      this.getGroups();
      this.getProvs();
      val || this.close();
    },
    affiliateDialog(val) {
      this.getInsurances();
      this.getGroups();
      this.getProvs();
      val || this.close();
    },
    organizationDialog(val) {
      this.getInsurances();
      val || this.close();
    },
    tab(selected) {
      // if affiliates tab is selected
      if (selected == 1) {
        this.getAffiliates();
      }
      // if organizations tab is selected
      if (selected == 2) {
        this.getOrganizations();
      }
    },
  },

  mounted() {
    this.getUser();
  },

  methods: {
    checkAffiliatesModal() {
      this.checkAffiliates = !this.checkAffiliates;
    },
    async checkAffiliatesReport() {
      this.affiliatesData = [];
      this.load = true;
      await axios
        .get(`/api/admin/checkAfilliatesReport/insurance=${this.insChoice}`)
        .then((response) => {
          this.affiliatesData = response.data;
        });
      this.load = false;
    },
    async getUser() {
      await axios
        .get('/api/user')
        .then((response) => {
          this.user = response.data[0];
        })
        .catch((err) => this.$router.push('/login'));

      this.initialize();
      this.getSuperUserSettings();
      this.checkPresets();
    },
    initialize() {
      if (this.user.role === 'Superuser') {
        axios.get('api/admin/allUsers').then((response) => {
          this.users = response.data;
          this.loading = false;
        });
      } else {
        axios.get('api/admin/visibleUsers').then((response) => {
          this.users = response.data;
          this.loading = false;
        });
      }
    },
    checkPresets() {
      const role = this.user.role && String(this.user.role).toLowerCase();
      if (role === 'admin' || role === 'superuser' || role === 'manager') {
        this.getOrgs();
      } else {
        this.$router.push('/membership');
      }
    },
    editItem(item) {
      this.creatingAffiliate = false;
      this.editedIndex = this.users.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.userDialog = true;
    },
    updateUser() {
      const username = this.editedItem.username.toLowerCase();
      const email = this.editedItem.email.toLowerCase();
      const password = 'welcome';
      const { role } = this.editedItem;
      const { insurance } = this.editedItem;
      const { organization } = this.editedItem;
      const { group } = this.editedItem;
      const { provider } = this.editedItem;
      const { location } = this.editedItem;

      const data = {
        username,
        email,
        password,
        role,
        insurance,
        organization,
        group,
        provider,
        location,
      };
      axios
        .post('/api/update', this.editedItem)
        .then((response) => {
          Object.assign(this.users[this.editedIndex], this.editedItem);
        })
        .catch((err) => {
          console.log(err);
          console.log("Couldn't update user.");
        });
      this.close();
      this.savedChanges = true;
      // confirm("Are you sure you want to delete this item?") && this.users.splice(index, 1);
    },
    deleteItem(item) {
      const index = this.users.indexOf(item);
      axios
        .post('/api/delete', item)
        .then(() => {
          this.users.splice(index, 1);
        })
        .catch((err) => {
          console.log(err);
          console.log("Couldn't delete user.");
        });
      // confirm("Are you sure you want to delete this item?") && this.users.splice(index, 1);
    },

    close() {
      this.userDialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    validate() {
      // Validate that data is correct before submitting
      if (this.$refs.form.validate()) {
        this.save();
      }
    },
    async save() {
      if (this.editedIndex > -1) {
        this.updateUser();
        this.close();
      } else {
        this.users.push(this.editedItem);
        await this.submitUser();
        if (this.emailCheck === true) {
          this.close();
        }
      }
    },
    async submitUser() {
      // Map form to the correct variables for user registration
      const username = this.editedItem.username.toLowerCase();
      const email = this.editedItem.email.toLowerCase();
      const password = 'welcome';
      const { role } = this.editedItem;
      const { insurance } = this.editedItem;
      const { organization } = this.editedItem;
      const { group } = this.editedItem;
      const { provider } = this.editedItem;
      const { location } = this.editedItem;

      const data = {
        username,
        email,
        password,
        role,
        insurance,
        organization,
        group,
        provider,
        location,
      };

      await axios
        .post('/api/register', data)
        .then(() => {
          this.initialize();
          console.log('Registered user successfully.');
        })
        .catch((err) => {
          if (err.response.status === 409) {
            this.emailCheck = false;
            this.snackbar = true;
          }
          console.log(err);
          console.log("Couldn't register user.");
        });
    },

    // Affiliates Tab
    getAffiliates() {
      this.loading = true;
      axios.get('api/admin/affiliates').then((response) => {
        this.affiliates = response.data;
        this.loading = false;
      });
    },
    editAffiliate(item) {
      this.editedAffiliateIndex = this.affiliates.indexOf(item);
      this.editedAffiliate = Object.assign({}, item);
      this.dataCopy = JSON.parse(JSON.stringify(this.editedAffiliate));
      this.affiliateDialog = true;
    },
    validateAffiliate() {
      // Validate that data is correct before submitting
      if (this.$refs.affiliateForm.validate()) {
        this.saveAffiliate();
      }
    },
    saveAffiliate() {
      if (this.editedAffiliateIndex > -1) {
        this.updateAffiliate();
      } else {
        this.affiliates.push(this.editedAffiliate);
        this.submitAffiliate();
      }
      this.closeAffiliate();
    },
    updateAffiliate() {
      //If there was a change to the active/inactive checkbox we build an object that holds the date and the change
      if (this.statusChange) {
        let editsObj = {
          date: this.activeDate,
          statusChange: this.editedAffiliate.Active ? 'Active' : 'Inactive',
        };
        this.editedAffiliate.Edits.unshift(editsObj);
      }
      axios
        .post('/api/admin/affiliates/update', this.editedAffiliate)
        .then((response) => {
          this.getAffiliates();
        })
        .catch((err) => {
          console.log(err);
          console.log("Couldn't update affiliate.");
        });
    },
    closeAffiliate() {
      this.affiliateDialog = false;
      this.creatingAffiliate = false;
      setTimeout(() => {
        this.editedAffiliate = Object.assign({}, this.defaultAffiliate);
        this.editedAffiliateIndex = -1;
      }, 300);
    },
    createAffiliate() {
      //for when you are not editing an affilitate will set the flag to show the option for adding the
      //Affiliates ID
      this.creatingAffiliate = true;
      this.editedAffiliate = Object.assign({}, this.defaultAffiliate);
      this.affiliateDialog = true;
    },
    async submitAffiliate() {
      await axios.post('/api/admin/affiliates/create', this.editedAffiliate).then((response) => {
        this.getAffiliates();
      });
    },

    // Organizations Tab
    getOrganizations() {
      this.loading = true;

      axios.get('api/admin/organizations').then((response) => {
        this.orgs = response.data;
        this.loading = false;
      });
    },
    editOrganization(item) {
      this.editedOrganizationIndex = this.orgs.indexOf(item);
      this.editedOrganization = Object.assign({}, item);
      this.organizationDialog = true;
    },
    validateOrganization() {
      // Validate that data is correct before submitting
      if (this.$refs.organizationForm.validate()) {
        this.saveOrganization();
      }
    },
    saveOrganization() {
      if (this.editedOrganizationIndex > -1) {
        this.updateOrganization();
      }
      this.closeOrganization();
    },
    updateOrganization() {
      axios
        .post('/api/admin/organizations/update', this.editedOrganization)
        .then((response) => {
          this.getOrganizations();
        })
        .catch((err) => {
          console.log(err);
          console.log("Couldn't update organization.");
        });
    },
    closeOrganization() {
      this.organizationDialog = false;
      setTimeout(() => {
        this.editedOrganization = Object.assign({}, this.defaultOrganization);
        this.editedOrganizationIndex = -1;
      }, 300);
    },

    // Superuser Stuff
    getSuperUserSettings() {
      // Query database to get settings for specific client -- TODO --
      if (this.user !== '') {
        axios.get('/api/admin/settings').then((response) => {
          this.app_plan = [];
          const { data } = response;
          this.superUserSettings = data;
          this.app_plan.push(this.superUserSettings.app_plan);
        });
      }
    },

    // Hierarchy Functions
    getOrgs() {
      const response = axios.get('api/list/organization').then((response) => {
        this.organizations = response.data;
        this.orgChoice = this.organizations;
      });
    },
    getInsurances() {
      const response = axios.get('api/list/insurances').then((response) => {
        this.insurances = response.data;
      });
    },
    getGroups() {
      this.groups = [];
      let url = '';

      if (this.tab == 0) {
        // if users tab is selected
        url = `api/list/${this.editedItem.insurance}/groups`;
      } else if (this.tab == 1) {
        // if affiliated tab is selected
        url = `api/list/${this.editedAffiliate.Plan}/groups`;
      }

      const response = axios.get(url).then((response) => {
        this.groups = response.data;
      });
    },
    getProvLocs() {
      this.locations = [];
      const provider = [];

      this.editedItem.provider.forEach((prov) => {
        console.log(prov.replace(/,/g, ' '));
        provider.push(prov);
      });

      axios.get(`api/selection/${provider}/locations`).then((response) => {
        const { data } = response;
        data.forEach((element) => {
          this.locations.push(element.Center_Location);
        });
      });
    },
    getProvs() {
      this.providers = [];
      this.locations = [];
      let url = '';
      if (this.tab == 0) {
        // if users tab is selected
        url = `api/selection/${this.editedItem.insurance}/group/${this.editedItem.group}`;
      } else if (this.tab == 1) {
        // if affiliated tab is selected
        url = `api/selection/${this.editedAffiliate.Plan}/group/${this.editedAffiliate.Group_Name}`;
      }

      axios.get(url).then((response) => {
        const { data } = response;
        this.groupObject = data;
        data.forEach((element) => {
          this.providers.push(element.Provide_Name);
          this.locations.push(element.Center_Location);
        });
      });
    },
    openPassDialog(item) {
      this.passDialog = true;
      this.selectedUser = item;
    },
    async resetPass() {
      await axios.post('/api/admin/resetpass', this.selectedUser);
      this.selectedUser = '';
      this.passDialog = false;
      this.initialize();
    },
  },
  computed: {
    adminDisabled() {
      if (this.user.role === 'Superuser') {
        return false;
      }
      return true;
    },
  },
};
</script>
